import React, { Component } from 'react';
import './InventoryOverviewCard.css';
import Card from '../../../components/card/Card';
import Label from '../../../components/label/Label';
import InventoryOverviewRow from './inventoryOverviewRow/InventoryOverviewRow';
import Divider from '../../../components/divider/Divider';
import mainAPI from '../../../api/MainAPI';
import models from '../../../model/models';
import classNames from 'classnames';
import InventoryDetailsRow from './inventoryDetailsRow/InventoryDetailsRow';
import cloneDeep from 'lodash.clonedeep';
import CardHeader from '../../../components/cardHeader/CardHeader';
import UniversalDropDown from '../../../components/universalDropDown/UniversalDropDown';

export default class InventoryOverviewCard extends Component {
	constructor(props) {
		super(props);
		this.state = { type: 'all', ready: true };
		this.old_state = {};
	}

	componentDidMount = () => {
		this._getData().then();
		this.subId = models.drug_type.onChange(this._drugTypesChanged);
		this.subGroupId = models.user_group.onChange(this._userGroupChanged);
		this.subUserId = models.user.onChange(this._userGroupChanged);
	};

	componentWillUnmount = () => {
		models.drug_type.unsubscribe(this.subId);
		models.user_group.unsubscribe(this.subGroupId);
		models.user.unsubscribe(this.subUserId);
	};

	_drugTypesChanged = () => {
		const drug_types = models.drug_type.allowed();
		this.setState({ drug_types });
	};

	_typeChanged = (value) => {
		this.old_state = cloneDeep(this.state);
		this.setState({ type: value, ready: false }, () => {
			setTimeout(() => {
				this.setState({ ready: true });
			}, 100);
		});
	};

	_userGroupChanged = () => {
		let user_group = models.user_group.obj();
		if (!user_group) return;
		if (user_group.id == 1573058908795) {
			// FIXME: Quick fix for Elite EMS
			this.setState({ user_group, type: 'activated_charcoal', ready: true }, () => {
				setTimeout(() => {
					this.setState({ ready: true });
				}, 100);
			});
		}
		else {
			this.setState({ user_group });
		}
	};

	_getData = async () => {
		let administered = await mainAPI.stock_move_record.administeredOfficial(this._timeStamp(30));
		if (!Array.isArray(administered)) administered = [];
		let wasted = await mainAPI.stock_move_record.wasted(this._timeStamp(30));
		if (!Array.isArray(wasted)) wasted = [];
		let usage = administered.concat(wasted);
		this.setState({ usage });
	};

	_timeStamp = (days) => {
		return Date.now() - 1000 * 60 * 60 * 24 * parseInt(days);
	};

	_parValueSupply = () => {
		let par = 0;
		let count = 0;
		for (let i in this.props.daysRemaining) {
			count++;
			par += this.props.daysRemaining[i] || 0;
		}
		if (par) {
			return par / count;
		}
		return 1;
	};

	_parValueVials = () => {
		let count = 0;
		for (let i in this.props.drugs) {
			if (this.props.drugs[i].stock_move_record__quantity > 0) {
				count++;
			}
		}
		if (count) {
			return count / 3;
		}
		return 1;
	};

	_renderInventoryRows = (old) => {
		let state = 'state';
		if (old) state = 'old_state';
		let drug_types = this[state].drug_types;
		let user_group = this[state].user_group || {};
		let par_values = user_group.par_values || {};
		let display = [];
		let divKey = -Date.now();
		let type = this[state].type;
		for (let i in drug_types) {
			if (type && type !== 'all' && i !== type) continue;
			display.push(
				<InventoryOverviewRow
					key={i}
					usage={this[state].usage}
					parVials={par_values[i]}
					parSupply={this._parValueSupply()}
					daysRemaining={this.props.daysRemaining[i]}
					drugs={this.props.drugs}
					type={i}
				/>
			);
			if (type && type !== 'all') continue;
			display.push(<Divider key={divKey--} />);
		}
		return display;
	};

	_renderInventoryDetails = (old) => {
		let state = 'state';
		if (old) state = 'old_state';
		if (!this[state].type || this[state].type === 'all') return null;
		return <InventoryDetailsRow type={this[state].type} />;
	};

	_lastContent = () => {
		let animate = this.state.ready;
		return (
			<div className={classNames('slide-container', 'old', { animate })}>
				{this._renderInventoryRows(true)}
				{this._renderInventoryDetails(true)}
				{/*<div className={'relative'}></div>*/}
			</div>
		);
	};

	_newContent = () => {
		let animate = this.state.ready;
		return (
			<div className={classNames('slide-container', 'new', { animate })}>
				{this._renderInventoryRows(false)}
				{this._renderInventoryDetails(false)}
			</div>
		);
	};

	_getClasses = () => {
		return 'g-inventory-overview-card';
	};

	_afterRender = () => {
		let drug_types = this.state.drug_types;
		if (this.state.type !== 'all') {
			try {
				return (document.querySelector('.g-inventory-overview-card').style.height = '');
			} catch (e) {}
		}
		let ct = 0;
		for (let i in drug_types) {
			ct++;
		}
		try {
			if (ct > 3) {
				let height = 140 + ct * 128;

				document.querySelector('.g-inventory-overview-card').style.height = height + 'px';
			} else {
				document.querySelector('.g-inventory-overview-card').style.height = '';
			}
		} catch (e) {}
	};

	render() {
		this._afterRender();
		return (
			<Card className={this._getClasses()}>
				<div className="top-row">
					<CardHeader>Inventory at a glance</CardHeader>
					<Label black>
						<div className="dot blue" />
						Deployed
					</Label>
					<Label black>
						<div className="dot dark-blue" />
						Supply
					</Label>
					<UniversalDropDown
						required
						endpoint={mainAPI.drug_type.allowed_drugs}
						onChange={this._typeChanged}
						options={{ all: 'All Drugs' }}
						value={this.state.type}
					/>
				</div>
				{this._lastContent()}
				{this._newContent()}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/dashboardPage/inventoryOverviewCard/InventoryOverviewCard.jsx